export default "__VITE_ASSET__Djro$Gbf__"